<!-- Show content only when authenticated or when auth is not required -->
@if (isAuthenticated) {
<div class="d-flex flex-column h-100">
  <app-header></app-header>
  <div role="main">
    <router-outlet></router-outlet>
  </div>
  <!-- Footer buttons container can go here -->
  <div class="footer-buttons-container">
    <!-- This is where you can add your sticky buttons that appear above the footer -->
  </div>
  <app-footer></app-footer>
</div>
} @else {
<!-- Show loading or blank screen while authentication is in progress -->
<div class="auth-loading-container">
  <div class="auth-loading-content">
    <div class="spinner"></div>
    <p>Checking authentication...</p>
  </div>
</div>
}